/* eslint-disable max-lines */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'
import ReferralCode from './referralCode'
import * as actions from '../../../actions'
import styles from '../../../constants/styles'
import { capitalizeString } from '../../../lib/format'
import countries from '../../../constants/countries'

import { ButtonLoadingCircularProgress } from '../icons/CircularProgress'
import { FormInputAvailable } from '../icons/Form'

const { countriesMain } = countries
const { otherCountries } = countries
const social = {
  facebook: 'facebook.com/',
  instagram: 'instagram.com/',
  tiktok: 'tiktok.com/@',
  twitter: 'twitter.com/',
  youtube: 'youtube.com/channel/'
}
class Form extends Component {
  constructor(props) {
    super(props)
    this.state = {
      clicked: {
        health: false,
        environment: false,
        animals: false
      },
      validEmail: false,
      loading: false
    }
    this.validateForm = this.validateForm.bind(this)
    this.submit = this.submit.bind(this)
    this.handleButtonClick = this.handleButtonClick.bind(this)
    this.submitButton = this.submitButton.bind(this)
  }

  componentDidMount() {
    const { form } = this.props
    if (form.email.length) {
      this.setState({ validEmail: true })
    }
  }

  validateEmail(email) {
    const { updateForm } = this.props
    const updated = email.trim().toLowerCase()
    updateForm('email', updated)
    if (
      !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        updated
      )
    ) {
      this.setState({ validEmail: false })
    } else {
      this.setState({ validEmail: true })
    }
  }

  // TODO fix
  // eslint-disable-next-line sonarjs/cognitive-complexity,complexity
  validateForm(e) {
    const { form, updateForm } = this.props
    // const { errors } = this.state
    const aux = {}
    e.preventDefault()
    if (!form.firstName.length) {
      aux.firstName = 'Your first name is required'
    }
    if (!form.lastName.length) {
      aux.lastName = 'Your last name is required'
    }
    if (!form.email.length) {
      aux.email = 'A valid email address is required'
    }
    if (
      !form.facebook &&
      !form.instagram &&
      !form.tiktok &&
      !form.twitter &&
      !form.youtube &&
      !form.website
    ) {
      aux.social = 'At least one social media account is required'
    }
    if (!form.country.length) {
      aux.country = 'Please choose your country'
    }
    if (!form.interests.length) {
      aux.interests = 'Please select an interest'
    }
    updateForm('errors', aux)
  }

  handleButtonClick(e, category, option) {
    const { updateForm } = this.props
    e.preventDefault()
    const aux = {
      health: false,
      environment: false,
      animals: false
    }
    aux[option] = true
    this.setState({ clicked: aux })
    updateForm(category, option)
  }

  // TODO fix
  // eslint-disable-next-line complexity
  submitButton() {
    const { form } = this.props
    const { loading, validEmail } = this.state
    if (
      form.firstName &&
      form.lastName &&
      form.email &&
      form.country &&
      form.interests &&
      (form.facebook ||
        form.instagram ||
        form.tiktok ||
        form.twitter ||
        form.youtube ||
        form.website) &&
      validEmail
    ) {
      return (
        <ActiveButton onClick={(e) => this.submit(e)}>
          {loading ? <ButtonLoadingCircularProgress /> : 'Submit'}
        </ActiveButton>
      )
    }
    return (
      <InactiveButton onClick={(e) => this.validateForm(e)}>
        Submit
      </InactiveButton>
    )
  }

  submit(e) {
    const { form, submitForm, setNextStep } = this.props
    e.preventDefault()
    submitForm({ form })
    setNextStep('success')
  }

  // TODO fix
  // eslint-disable-next-line sonarjs/cognitive-complexity,complexity
  render() {
    const { form, updateForm } = this.props
    const { clicked, validEmail } = this.state

    return (
      <Main>
        <JoinForm>
          <Header> Personal details</Header>
          <Field>
            <ReferralCode code={form.username} marginBottom={'20px'} />
            <Label for="firstName">First Name*</Label>
            <InputBox>
              <Input
                autoFocus
                name="firstName"
                type="text"
                value={form.firstName}
                onChange={(e) => updateForm('firstName', e.target.value)}
              />
              {!!form.firstName.length && (
                <Icon>
                  <FormInputAvailable sx={{ color: 'green' }} />
                </Icon>
              )}
            </InputBox>
            {form.errors.firstName && <Error>{form.errors.firstName}</Error>}
          </Field>

          <Field>
            <Label for="lastName">Last Name*</Label>
            <InputBox>
              <Input
                name="lastName"
                type="text"
                value={form.lastName}
                onChange={(e) => updateForm('lastName', e.target.value)}
              />
              {!!form.lastName.length && (
                <Icon>
                  <FormInputAvailable sx={{ color: 'green' }} />
                </Icon>
              )}
            </InputBox>
            {form.errors.lastName && <Error>{form.errors.lastName}</Error>}
          </Field>

          <Field>
            <Label for="email">Email*</Label>
            <InputBox>
              <Input
                name="email"
                type="text"
                value={form.email}
                onChange={(e) => this.validateEmail(e.target.value)}
              />
              {validEmail && (
                <Icon>
                  <FormInputAvailable sx={{ color: 'green' }} />
                </Icon>
              )}
            </InputBox>
            {form.errors.email && <Error>{form.errors.email}</Error>}
          </Field>

          <Header>Social media details</Header>
          <Text>
            We&apos;ll be verifying your identity through social media.
          </Text>
          <Text>Please include the link to at least one account.</Text>
          <Field>
            <Label for="facebook">Facebook</Label>
            <InputBox>
              <Social>{social.facebook}</Social>
              <Input
                name="facebook"
                type="text"
                value={form.facebook}
                onChange={(e) => updateForm('facebook', e.target.value)}
              />
              {!!form.facebook.length && (
                <Icon>
                  <FormInputAvailable sx={{ color: 'green' }} />
                </Icon>
              )}
            </InputBox>
          </Field>

          <Field>
            <Label for="instagram">Instagram</Label>
            <InputBox>
              <Social>{social.instagram}</Social>
              <Input
                name="instagram"
                type="text"
                value={form.instagram}
                onChange={(e) => updateForm('instagram', e.target.value)}
              />
              {!!form.instagram.length && (
                <Icon>
                  <FormInputAvailable sx={{ color: 'green' }} />
                </Icon>
              )}
            </InputBox>
          </Field>

          <Field>
            <Label for="tiktok">TikTok</Label>
            <InputBox>
              <Social>{social.tiktok}</Social>
              <Input
                name="tiktok"
                type="text"
                value={form.tiktok}
                onChange={(e) => updateForm('tiktok', e.target.value)}
              />
              {!!form.tiktok.length && (
                <Icon>
                  <FormInputAvailable sx={{ color: 'green' }} />
                </Icon>
              )}
            </InputBox>
          </Field>

          <Field>
            <Label for="twitter">Twitter</Label>
            <InputBox>
              <Social>{social.twitter}</Social>
              <Input
                name="twitter"
                type="text"
                value={form.twitter}
                onChange={(e) => updateForm('twitter', e.target.value)}
              />
              {!!form.twitter.length && (
                <Icon>
                  <FormInputAvailable sx={{ color: 'green' }} />
                </Icon>
              )}
            </InputBox>
          </Field>

          <Field>
            <Label for="youtube">Youtube</Label>
            <InputBox>
              <Social>{social.youtube}</Social>
              <Input
                name="youtube"
                type="text"
                value={form.youtube}
                onChange={(e) => updateForm('youtube', e.target.value)}
              />
              {!!form.youtube.length && (
                <Icon>
                  <FormInputAvailable sx={{ color: 'green' }} />
                </Icon>
              )}
            </InputBox>
          </Field>

          <Field>
            <Label for="website">Website</Label>
            <InputBox>
              <Input
                name="website"
                type="text"
                value={form.website}
                onChange={(e) => updateForm('website', e.target.value)}
              />
              {!!form.website.length && (
                <Icon>
                  <FormInputAvailable sx={{ color: 'green' }} />
                </Icon>
              )}
            </InputBox>

            {form.errors.social && <Error>{form.errors.social}</Error>}
          </Field>

          <Header>Tell us more</Header>

          <Field>
            <SubHeader>Where are you located?</SubHeader>
            <Label for="country">Country*</Label>

            <SelectContainer>
              <Select
                name="country"
                onChange={(e) => updateForm('country', e.target.value)}
              >
                <Option>Select a country</Option>
                {countriesMain
                  .filter((country) => country !== 'The World')
                  .map((c) => (
                    <Option key={c} value={c}>
                      {c}
                    </Option>
                  ))}
                {otherCountries.map((c) => (
                  <Option key={c} value={c}>
                    {c}
                  </Option>
                ))}
              </Select>
            </SelectContainer>
            {form.errors.country && <Error>{form.errors.country}</Error>}
          </Field>

          <Field>
            <Label for="city">City</Label>
            <InputBox>
              <Input
                name="city"
                type="text"
                value={form.city}
                onChange={(e) => updateForm('city', e.target.value)}
              />
              {!!form.city.length && (
                <Icon>
                  <FormInputAvailable sx={{ color: 'green' }} />
                </Icon>
              )}
            </InputBox>
            {form.errors.city && <Error>{form.errors.city}</Error>}
          </Field>

          <Field>
            <SubHeader>
              Why are you primarily interested in veganism?*
            </SubHeader>
            <ButtonsBox>
              {['animals', 'environment', 'health'].map((option) => (
                <Button
                  type="button"
                  onClick={(e) =>
                    this.handleButtonClick(e, 'interests', option)
                  }
                  key={option}
                  value={form.interests}
                  isClicked={clicked[option]}
                >
                  {capitalizeString(option)}
                </Button>
              ))}
            </ButtonsBox>

            {form.errors.interests && <Error>{form.errors.interests}</Error>}
          </Field>

          <Field>
            <SubHeader>
              Is there anything else you would like us to know?
            </SubHeader>
            <InputBox isDouble>
              <Textarea
                isDouble
                name="remarks"
                type="text"
                value={form.remarks}
                onChange={(e) => updateForm('remarks', e.target.value)}
              />
            </InputBox>
          </Field>

          {this.submitButton()}

          {Object.values(form.errors).length > 0 && (
            <div
              style={{
                marginBottom: styles.margin.medium,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
              }}
            >
              {Object.values(form.errors).map((error) => (
                <span key={error} style={{ color: styles.colors.action }}>
                  {error}
                </span>
              ))}
            </div>
          )}
        </JoinForm>
      </Main>
    )
  }
}

Form.propTypes = {
  form: PropTypes.objectOf(PropTypes.any).isRequired,
  updateForm: PropTypes.func.isRequired,
  submitForm: PropTypes.func.isRequired,
  setNextStep: PropTypes.func.isRequired
}

const mapStateToProps = (state) => ({
  viewer: state.users.viewer._id ? state.users.all[state.users.viewer._id] : {},
  form: state.ambassadors.form
})

const mapDispatchToProps = (dispatch) => ({
  updateForm: (category, value) => {
    dispatch({ type: actions.UPDATE_FORM_AMBASSADOR, category, value })
    if (category !== 'errors') {
      dispatch({
        type: actions.UPDATE_FORM_AMBASSADOR,
        category: 'errors',
        value: {}
      })
    }
  },
  submitForm: ({ form }) => {
    dispatch(actions.ambassadors.submitForm({ form }))
  },
  setNextStep: (step) => {
    dispatch({ type: actions.SET_NEXT_STEP, step })
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(Form)

const Main = styled.main`
  width: 100%;
  min-height: calc(100vh - 96px);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 ${styles.padding.medium};
`

const JoinForm = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`
const Header = styled.h2`
  font-size: 1.2em;
  margin: 30px 0 8px;
`
const SubHeader = styled.h3`
  font-size: 1em;
  margin-bottom: ${styles.margin.medium};
  @media (max-width: 600) {
    font-size: 0.9em;
  }
`

const Field = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: ${styles.margin.medium};

  @media (min-width: 800px) {
    width: 600px;
  }
`

const Label = styled.label`
  font-size: 1em;
  text-align: left;
  color: ${styles.colors.darkGrey};
  padding-left: ${styles.padding.small};

  @media (min-width: 800px) {
    font-size: 0.9em;
  }
`

const Text = styled(Label)`
  text-align: center;
`

const InputBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-radius: 4px;
  background-color: #efeff4;
  padding-left: ${styles.padding.small};
`

const Social = styled.span`
  font-size: 1em;
  padding: ${styles.padding.small} 0;
`

const Input = styled.input`
  flex: 9;
  background-color: #efeff4;
  font-size: 1em;
  resize: none;
  padding: ${styles.padding.small};
  padding-left: 0;
`

const Textarea = styled.textarea`
  flex: 9;
  background-color: #efeff4;
  font-size: 1em;
  resize: none;
  padding: ${styles.padding.small};
  height: 120px;
`

const Icon = styled.i`
  display: flex;
  align-items: center;
  font-size: 1em;
  flex: 1;
`

const SelectContainer = styled.div`
  width: 100%;
  padding: ${styles.padding.small};
  background-color: #efeff4;
`

const Select = styled.select`
  width: 100%;
  height: 100%;
  border: none;
  font-size: 1em;
  color: ${styles.colors.black};
  box-shadow: none;
  background: transparent;
  background-image: none;
  -webkit-appearance: none;
  cursor: pointer;
  text-align: center;
  display: flex;
  justify-content: center;
`
const ButtonsBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
const Button = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80%;
  font-size: 1em;
  background-color: ${(props) =>
    props.isClicked ? styles.colors.ambassador : '#efeff4'};
  padding: ${styles.padding.tiny} 100px;
  margin: ${styles.margin.tiny};
  border-radius: 30px;
  cursor: pointer;
  text-align: center;
  color: ${(props) => (props.isClicked ? styles.colors.white : 'black')};
  &:hover {
    color: ${styles.colors.white};
    background-color: ${styles.colors.ambassador};
  }

  @media (min-width: 800px) {
    width: 400px;
    font-size: 0.9em;
    padding: ${styles.padding.small} 100px;
  }
`

const Error = styled.p`
  color: red;
  font-size: 0.7em;
`

const Option = styled.option``

const ActiveButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: ${styles.margin.large};
  padding: ${styles.padding.tiny} 80px;
  color: ${styles.colors.white};
  background-color: ${styles.colors.ambassador};
  font-size: 1em;
  border-radius: 30px;
  border: 3px solid ${styles.colors.ambassador};
  cursor: pointer;
  font-weight: 600;
  &:hover {
    color: ${styles.colors.ambassador};
    background-color: ${styles.colors.white};
  }
`
const InactiveButton = styled(ActiveButton)`
  background-color: #efeff4;
  border: 3px solid #efeff4;
  color: ${styles.colors.darkGrey};
  cursor: auto;
  &:hover {
    background-color: #efeff4;
    border: 3px solid #efeff4;
    color: ${styles.colors.darkGrey};
  }
`
